import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CheckItem } from "../checkbox-block/checkbox-block.component";

@Component({
  selector: "app-checkbox-item",
  templateUrl: "./checkbox-item.component.html",
  styleUrls: ["./checkbox-item.component.scss"],
})
export class CheckboxItemComponent {
  @Input() item!: CheckItem;
  @Input() isDisabled = false;

  //* Используй этот флаг если локализация на стороне back-end
  @Input() isLocalized = false;

  @Output() changeItem: EventEmitter<CheckItem> = new EventEmitter<CheckItem>();

  checkChange(item: CheckItem) {
    this.changeItem.emit(item);
  }
}
